import React from 'react';

import { TextField, TextFieldProps } from '@lumapps/lumx/react';

import { FILTERS_MODE } from '../../constants';
import { useFilterUIProps } from '../../hooks/useFilterUIProps';
import { UseTextFilter, useTextFilter, UseTextFilterOptions } from '../../hooks/useTextFilter';
import { Filter, type FilterProps } from '../Filter';

export interface TextFilterProps extends FilterProps {
    /** list of options to display as chips */
    selection?: string;
    /** onSelected callback, generated from the `useListFilter` hook */
    onSelected?: UseTextFilter['onSelected'];
    /** additional text field props */
    textFieldProps?: Partial<TextFieldProps>;
    /** default values */
    defaults?: UseTextFilterOptions;
}

const CLASSNAME = 'text-field-filter';
/**
 * Filter that renders a text field as a filter.
 * @family Filters
 * @param TextFilterProps
 * @returns TextFilter
 */
export const TextFilter = ({
    selection,
    onSelected,
    textFieldProps = {},
    mode,
    className,
    ...props
}: TextFilterProps) => {
    const filterUIProps = useFilterUIProps({
        parentClassName: CLASSNAME,
        className,
    });

    const title = mode === FILTERS_MODE.EXPOSED_FACETS ? undefined : props.title;

    return (
        <Filter {...props} hideTitle mode={mode}>
            <TextField
                className={filterUIProps.className}
                value={selection}
                onChange={(val) => onSelected?.(val)}
                {...textFieldProps}
                label={title}
                // @ts-expect-error labelProps should be Partial, we should fix it on the DS side.
                labelProps={{
                    ...textFieldProps.labelProps,
                    children: title,
                    typography: filterUIProps.typography,
                }}
            />
        </Filter>
    );
};

Object.assign(TextFilter, { hook: useTextFilter });
